module.exports = __webpack_public_path__ + "static/media/subscriptions-icon.19bd1a56.svg";